fragment paymentLinkDetailsFields on PaymentLinkDetails {
  id
  status
  timeGenerated
  url
  sendAppointmentCancellationClientReminderUsingEmail
  sendAppointmentCancellationClientReminderUsingSms
}
